// extracted by mini-css-extract-plugin
export default {"skeleton":"empty_skeleton__63spt","pulse":"empty_pulse__3NgAb"};